<template>
  <div id="features-page" class="bc-black">
    <div class="w-100 c-max-w">
      <router-view></router-view>
    </div>
    <FooterCTA
      overline="GET STARTED"
      title-html="Upgrade <span class='grey'>your demo inbox</span>"
      button-text="CREATE ACCOUNT"
      button-to="/sign_up"
    />
  </div>
</template>
<script>
import FooterCTA from '@/components/features/FooterCTA.vue'

export default {
  name: 'FeaturesPage',
  components: {
    FooterCTA,
  },
  metaInfo: {
    title: 'Features',
  },
}
</script>
<style lang="scss">
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";
</style>
